import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import ProfileStore from 'stores/ProfileStore';
import Button from 'components/Button/Button';
import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';

import styles from './ChatActionButton.css';


function ChatActionButton(props) {
  const {
    icon,
    id,
    embedProfileV2,
    shouldRun,
    time,
    onClick,
  } = props;

  const { isPlayerBroadcastMode } = ProfileStore;

  const [timer, setTimer] = useState(null);

  const iconEl = <img alt="" src={icon} />;

  useEffect(() => {
    if (time && shouldRun) {
      const countdown = setInterval(() => {
        const timeLeft = moment(time).diff(moment());
        if (timeLeft < 0) {
          setTimer(null);
          clearInterval(countdown);
        } else {
          const formatted = moment(timeLeft).format('mm:ss');
          setTimer(formatted);
        }
      }, SECOND_AS_MILLISECONDS);

      return () => {
        clearInterval(countdown);
      };
    }

    setTimer(null);

    return undefined;
  }, [time, shouldRun]);

  const onAction = useCallback(() => {
    if (!shouldRun) {
      onClick();
    }
  }, [onClick, shouldRun]);

  const wrapperClass = classNames({
    [styles.btnEmbed]: embedProfileV2,
    [styles.btn]: !embedProfileV2,
  });

  return (
    <div className={styles.container}>
      <Button
        className={wrapperClass}
        disabled={isPlayerBroadcastMode}
        icon={iconEl}
        id={id}
        onClick={onAction}
      />
      {Boolean(time) && (
        <div
          className={styles.timer}
          id={`${id}_lockTimer`}
        >
          {timer}
        </div>
      )}
    </div>
  );
}

ChatActionButton.propTypes = {
  icon: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  embedProfileV2: PropTypes.bool,
  shouldRun: PropTypes.bool,
  time: PropTypes.number,
};

ChatActionButton.defaultProps = {
  embedProfileV2: false,
  shouldRun: false,
  time: undefined,
};

export default ChatActionButton;
